/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Overlay_CloseInputs */

const en_us2_ui_overlay_close = /** @type {(inputs: Ui_Overlay_CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Close`)
};

const pt_br2_ui_overlay_close = /** @type {(inputs: Ui_Overlay_CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fechar`)
};

const es_419_ui_overlay_close = /** @type {(inputs: Ui_Overlay_CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cerrar`)
};

const pt_pt2_ui_overlay_close = /** @type {(inputs: Ui_Overlay_CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fechar`)
};

const fr_fr2_ui_overlay_close = /** @type {(inputs: Ui_Overlay_CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fermer`)
};

const de_de2_ui_overlay_close = /** @type {(inputs: Ui_Overlay_CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schließen`)
};

const it_it2_ui_overlay_close = /** @type {(inputs: Ui_Overlay_CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chiudi`)
};

/**
* | output |
* | --- |
* | "Close" |
*
* @param {Ui_Overlay_CloseInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const ui_overlay_close = /** @type {((inputs?: Ui_Overlay_CloseInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Overlay_CloseInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_ui_overlay_close(inputs)
	if (locale === "es-419") return es_419_ui_overlay_close(inputs)
	if (locale === "pt-PT") return pt_pt2_ui_overlay_close(inputs)
	if (locale === "fr-FR") return fr_fr2_ui_overlay_close(inputs)
	if (locale === "de-DE") return de_de2_ui_overlay_close(inputs)
	if (locale === "it-IT") return it_it2_ui_overlay_close(inputs)
	return en_us2_ui_overlay_close(inputs)
});
export { ui_overlay_close as "ui-overlay.close" }